<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'inform',
})
</script>
<template>
    <div class="chat-container">
        <!-- 消息列表区 -->
        <div class="chat-message-list" ref="messageListRef">
            <a-spin :spinning="data.loading">
                <div v-for="(item, index) in data.chatList" :key="index" class="chat-message-row"
                    :class="item.is_private == 1 ? 'chat-message-left' : 'chat-message-right'">
                    <p class="chat-time" v-if="showTime(index)">
                        {{ item.created_at }}
                    </p>

                    <div class="chat-message-main">
                        <div class="chat-avatar" :title="item.side_roles_title"
                            :class="'avater' + item.side_roles_class">
                            {{ item.side_roles_name }}
                        </div>
                        <a-spin :spinning="item.sending == 1" class="chat-bubble-wrapper">
                            <div class="chat-bubble"
                                :class="item.is_private == 1 ? 'chat-bubble-left' : 'chat-bubble-right'">
                                <div>
                                    <span v-html="item.msg" class="chat-msg-text"></span>
                                </div>
                                <!-- 正常渲染图片/附件 -->
                                <div class="chat-attachment" v-if="item.attachment">
                                    <span v-for="(itemaa, idx) in item.attachment" :key="idx">
                                        <a-image v-if="isImage(itemaa.name)" :width="120" :height="50"
                                            :src="$store.state.user.image_domain + itemaa.url">
                                        </a-image>
                                        <p v-else>
                                            <a :href="$store.state.user.image_domain + itemaa.url" target="_blank">
                                                {{ itemaa.name }}
                                            </a>
                                        </p>
                                    </span>
                                </div>
                            </div>
                        </a-spin>
                    </div>

                    <div class="chat-speaker" v-if="item.is_send == 1">
                        <a class="ml-2x" @click="handleSpeaker(item)">
                            <NotificationOutlined /> 发送至云喇叭通知
                        </a>
                    </div>
                </div>
            </a-spin>
        </div>

        <!-- 底部操作区 -->
        <div class="chat-footer-area">
            <!-- 抄送行 -->
            <div class="chat-cc-row">
                <span class="cc-label">抄送：</span>
                <a-select allow-clear v-model:value="goutonFrom.tels" mode="multiple" style="width: 250px" size="small"
                    placeholder="请选择" :options="data.tels" @change="handleChange">
                </a-select>
            </div>

            <!-- 聊天输入区 -->
            <div class="chat-input-box">
                <!-- 输入框 -->
                <a-textarea v-model:value="goutonFrom.msg" :auto-size="{ minRows: 3, maxRows: 6 }" placeholder="输入消息..."
                    class="chat-textarea" @keydown.enter.exact.prevent="fabugouton" />

                <!-- 附件预览区 -->
                <div v-if="goutonFrom.attachment && goutonFrom.attachment.length > 0" class="attachment-preview">
                    <a-tag v-for="(file, fIndex) in goutonFrom.attachment" :key="fIndex" closable
                        @close="removeAttachment(fIndex)" color="blue">
                        <span
                            style="display:inline-block; max-width: 120px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; vertical-align: bottom;">
                            {{ file.name }}
                        </span>
                    </a-tag>
                </div>

                <!-- 底部工具栏 -->
                <div class="chat-input-toolbar">
                    <div class="toolbar-left">
                        <!-- 原生隐藏 input -->
                        <input type="file" ref="fileInputRef" style="display: none;" multiple
                            accept=".pdf,.doc,.docx,.xls,.xlsx,.jpeg,.jpg,.png" @change="handleFileChange" />
                        <!-- 自定义回形针图标，点击触发原生 input -->
                        <div class="icon-btn" title="上传附件" @click="triggerFileInput">
                            <a-spin v-if="data.uploadLoading" size="small" />
                            <svg v-else viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path
                                    d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48">
                                </path>
                            </svg>
                        </div>
                    </div>

                    <!-- 小飞机直接发送 -->
                    <button class="chat-send-btn" :disabled="data.submitLoading || data.uploadLoading" type="button"
                        @click="fabugouton">
                        <a-spin v-if="data.submitLoading" size="small" />
                        <svg v-else viewBox="0 0 24 24" width="22" height="22" fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup name="inform">
import { message } from 'ant-design-vue'
import { useStore } from 'vuex'
import { ref, watch, reactive, nextTick } from 'vue'
import baseService from '@/utils/http/axios'
import { NotificationOutlined } from '@ant-design/icons-vue'
import ls from '@/utils/Storage' // 引入你们原有的 token 获取方式

const $store = useStore()

const props = defineProps({
    lianxirenData: {
        type: Object,
        default: () => ({})
    }
})

interface data {
    loading: boolean
    submitLoading: boolean
    uploadLoading: boolean
    chatList: any[]
    tels: any[]
    side_id: number
}

const data = reactive<data>({
    loading: false,
    submitLoading: false,
    uploadLoading: false,
    chatList: [],
    tels: [],
    side_id: 0
})

const messageListRef = ref<HTMLDivElement | null>(null)
const fileInputRef = ref<HTMLInputElement | null>(null)

const showTime = (index: number) => {
    if (index === 0) return true
    const prev = data.chatList[index - 1]
    const cur = data.chatList[index]
    if (!prev?.created_at || !cur?.created_at) return true
    const prevTime = new Date(prev.created_at).getTime()
    const curTime = new Date(cur.created_at).getTime()
    return Math.abs(curTime - prevTime) > 5 * 60 * 1000
}

const isImage = (name: string) => {
    if (!name) return false
    return /\.(jpg|jpeg|png)$/i.test(name)
}

watch(
    () => props.lianxirenData.key,
    (val) => {
        if (val) {
            initData()
        }
    },
    { deep: true, immediate: true }
)

const initData = () => {
    data.chatList = []
    data.tels = []
    getChatList()
    getCtelInfo()
}

const scrollToBottom = () => {
    nextTick(() => {
        const el = messageListRef.value
        if (el) {
            el.scrollTop = el.scrollHeight
        }
    })
}

const getChatList = () => {
    data.loading = true
    let requestParam = {
        url: '/admin/v1/memberChatList',
        method: 'post',
        data: {
            customer_id: props.lianxirenData.customer_id,
            side: props.lianxirenData.side,
            limit: 'all',
            page: 1
        }
    }
    baseService(requestParam)
        .then((res) => {
            data.loading = false
            data.chatList = res.data.list
            scrollToBottom()
        })
        .catch(() => {
            data.loading = false
        })
}

const goutonFrom = reactive<any>({
    customer_id: props.lianxirenData.customer_id,
    msg: '',
    attachment: [],
    tels: []
})

const handleChange = (value: string[]) => {
    goutonFrom.tels = value
}

// ================= 附件上传逻辑 =================
const triggerFileInput = () => {
    if (data.uploadLoading) return
    if (fileInputRef.value) {
        fileInputRef.value.value = ''
        fileInputRef.value.click()
    }
}

const handleFileChange = (event: Event) => {
    const target = event.target as HTMLInputElement
    const files = target.files
    if (!files || files.length === 0) return

    if (goutonFrom.attachment.length + files.length > 9) {
        message.warning('最多只能上传 9 个附件')
        return
    }

    const acceptTypes = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpeg', 'jpg', 'png']
    let validFiles: File[] = []

    Array.from(files).forEach((file: File) => {
        const ext = file.name.split('.').pop()?.toLowerCase() || ''
        if (!acceptTypes.includes(ext)) {
            message.error(`不支持的文件格式: ${file.name}`)
            return
        }
        if (file.size > 10 * 1024 * 1024) {
            message.error(`文件大小不能超过 10MB: ${file.name}`)
            return
        }
        validFiles.push(file)
    })

    if (validFiles.length === 0) return

    // 开始上传
    data.uploadLoading = true
    const formData = new FormData()
    // 这里的字段名参考了你们 Upload.vue 的源码
    formData.append('file', validFiles[0])
    // 这里的路径是你们的特殊加密方式
    formData.append('upload_path', btoa(encodeURIComponent(props.lianxirenData.upload_path + '微信沟通/')))
    // 这是你们组件里附带的参数，可能后端有校验
    formData.append('imgLimitSize', '5')

    // 你们真实的上传接口地址
    let uploadUrl = '/hncskaiyela/admin/v1/upload'

    baseService({
        url: uploadUrl,
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': ls.get('ACCESS_TOKEN') // 加上 token
        }
    }).then((res: any) => {
        // 你们接口返回的格式：{ data: { url: 'xxx' } }
        const realUrl = res.data?.url || res.data?.path

        if (realUrl) {
            goutonFrom.attachment.push({
                name: validFiles[0].name,
                url: realUrl,
                size: validFiles[0].size
            })
            message.success('上传成功')
        } else {
            message.error('上传失败：接口未返回文件路径')
        }
    }).catch((err) => {
        console.error(err)
        message.error('文件上传失败，请重试')
    }).finally(() => {
        data.uploadLoading = false
    })
}

const removeAttachment = (index: number) => {
    goutonFrom.attachment.splice(index, 1)
}

// ==============================================

const fabugouton = () => {
    if (data.uploadLoading) {
        message.warning('附件正在上传中，请稍候...')
        return
    }

    const hasMsg = goutonFrom.msg && goutonFrom.msg.trim() !== ''
    const hasAttachment = goutonFrom.attachment && goutonFrom.attachment.length > 0

    if (!hasMsg && !hasAttachment) {
        message.warning('请输入消息内容或上传附件')
        return
    }

    let tels = [...goutonFrom.tels]
    tels.push(data.side_id)

    const formatAttachment = (goutonFrom.attachment || []).map((item: any) => {
        return {
            url: item.url,
            name: item.name
        }
    })

    let postData = {
        customer_id: props.lianxirenData.customer_id,
        tels: tels,
        msg: goutonFrom.msg || '',
        attachment: formatAttachment
    }

    data.submitLoading = true
    let requestParam = {
        url: '/admin/v1/addCustomerChat',
        method: 'post',
        data: postData
    }
    baseService(requestParam)
        .then(() => {
            message.success('发送成功')
            goutonFrom.msg = ''
            goutonFrom.attachment = []
            goutonFrom.tels = []
            getChatList()
            data.submitLoading = false
        })
        .catch((res) => {
            data.submitLoading = false
            message.error(res.msg || '发送失败')
        })
}

const getCtelInfo = () => {
    let requeryParam = {
        url:
            `/admin/v1/getCtelInfo?customer_id=` +
            props.lianxirenData.customer_id +
            '&side=' +
            props.lianxirenData.side,
        method: 'get'
    }
    baseService(requeryParam).then((res) => {
        data.tels = res.data.tels
        data.side_id = res.data.side_id
    })
}

const handleSpeaker = (record) => {
    record.sending = 1
    let requeryParam = {
        url: '/admin/v1/chatSendSpeaker',
        method: 'post',
        data: { id: record.id }
    }
    baseService(requeryParam)
        .then(() => {
            message.info('发送成功！')
        })
        .catch((res) => {
            message.error(res.msg)
        })
        .finally(() => {
            record.sending = 0
        })
}
</script>

<style lang="less" scoped>
.chat-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: #f5f5f5;
}

.chat-message-list {
    flex: 1;
    overflow-y: auto;
    padding: 10px 16px;
    min-height: 300px;
}

.chat-message-row {
    margin-bottom: 18px;
}

.chat-message-left {
    text-align: left;
}

.chat-message-right {
    text-align: right;
}

.chat-time {
    text-align: center;
    font-size: 12px;
    color: #999;
    margin: 8px 0;
}

.chat-message-main {
    display: flex;
    align-items: flex-start;
    gap: 10px;
}

.chat-message-right .chat-message-main {
    flex-direction: row-reverse;
}

.chat-avatar {
    width: 44px;
    height: 44px;
    border-radius: 6px;
    text-align: center;
    padding: 3px;
    font-size: 12px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    overflow: hidden;
}

.chat-bubble-wrapper {
    display: inline-block;
    max-width: 70%;
}

.chat-bubble {
    position: relative;
    padding: 10px 14px;
    border-radius: 8px;
    word-break: break-all;
    text-align: left;
    font-size: 14px;
    line-height: 1.5;
}

.chat-bubble-left {
    background: #fff;
    color: #333;
    border: 1px solid #e8e8e8;
}

.chat-bubble-left::before {
    content: '';
    position: absolute;
    left: -8px;
    top: 12px;
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 8px solid #fff;
}

.chat-bubble-right {
    background: #95ec69;
    color: #000;
}

.chat-bubble-right::after {
    content: '';
    position: absolute;
    right: -8px;
    top: 12px;
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 8px solid #95ec69;
}

.chat-msg-text {
    line-height: 24px;
}

.chat-attachment {
    padding-top: 6px;
}

:deep(.ant-image) {
    margin-right: 8px;
    margin-bottom: 8px;
}

.chat-speaker {
    margin-top: 6px;
    font-size: 12px;
    padding-left: 54px;
}

.chat-message-right .chat-speaker {
    padding-left: 0;
    padding-right: 54px;
}

.chat-footer-area {
    background: #fff;
    border-top: 1px solid #e8e8e8;
    padding: 16px 20px;
    flex-shrink: 0;
}

.chat-cc-row {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    padding-left: 4px;
}

/* 针对抄送行的下拉框进行圆润化 */
.chat-cc-row :deep(.ant-select-selector) {
    border-radius: 6px !important;
}

.cc-label {
    font-size: 13px;
    color: #666;
    margin-right: 8px;
    font-weight: 500;
}

.chat-input-box {
    background: #f5f5f5;
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    padding: 12px 14px;
    transition: border-color 0.2s;
}

.chat-input-box:focus-within {
    border-color: #07c160;
}

.chat-textarea {
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    resize: none;
    font-size: 14px;
    padding: 0;
    line-height: 1.6;
    width: 100%;
}

.chat-textarea:focus {
    box-shadow: none !important;
}

.attachment-preview {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px dashed #d9d9d9;
}

.attachment-preview :deep(.ant-tag) {
    margin: 0;
    display: flex;
    align-items: center;
    padding: 4px 8px;
}

.chat-input-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 12px;
}

.toolbar-left {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
}

.icon-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 6px;
    color: #666;
    cursor: pointer;
    transition: all 0.2s;
}

.icon-btn:hover {
    background: #e8e8e8;
    color: #333;
}

.chat-send-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: none;
    background: #07c160;
    color: #fff;
    cursor: pointer;
    flex-shrink: 0;
    transition: background 0.2s, transform 0.1s;
    box-shadow: 0 2px 6px rgba(7, 193, 96, 0.3);
}

.chat-send-btn:hover {
    background: #06ad56;
}

.chat-send-btn:active {
    transform: scale(0.92);
}

.chat-send-btn:disabled {
    background: #ccc;
    box-shadow: none;
    cursor: not-allowed;
    opacity: 0.7;
}

.chat-send-btn svg {
    display: block;
    margin-left: -2px;
}

/* 头像颜色 */
.avater0 {
    background-color: red;
}

.avater1 {
    background-color: #13c2c2;
}

.avater2 {
    background-color: red;
}

.avater3 {
    background-color: #3f8cff;
}

.avater4 {
    background-color: red;
}

.avater5 {
    background-color: red;
}

.avater6 {
    background-color: red;
}

.avater7 {
    background-color: #faad14;
}

.avater8 {
    background-color: red;
}

.avater9 {
    background-color: red;
}

.avater10 {
    background-color: red;
}

.avater11 {
    background-color: red;
}

.avater12 {
    background-color: red;
}

.avater13 {
    background-color: red;
}
</style>
